import React from 'react';
import KeyboardWizard from "./KeyboardWizard";
import onboarding from "../../../services/onboarding/onboarding";

export default function KeyboardWizardPage() {

  return (
    <>
      <KeyboardWizard onStartPlaying={() => {
        onboarding.completeOnboarding();
      }} mode={"fullscreen"}/>
    </>
  );
}
